import ProfileDetailUserDataPayments from './ProfileDetailUserDataPayments';

export * from './types';

export default ProfileDetailUserDataPayments;
